var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper task-list" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { "separator-class": "el-icon-arrow-right" } },
          [
            _c(
              "el-breadcrumb-item",
              { attrs: { to: { path: "/tool/classAssign/intro" } } },
              [_vm._v("精准教学分班")]
            ),
            _c(
              "el-breadcrumb-item",
              { attrs: { to: { path: "/tool/classAssign/list" } } },
              [_vm._v("精准教学分班汇总")]
            ),
            _c("el-breadcrumb-item", [_vm._v("新增记录")]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "main" }, [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "data-container" },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: "分班名称：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { placeholder: "请输入分班班级名称" },
                    model: {
                      value: _vm.uploadData.taskName,
                      callback: function ($$v) {
                        _vm.$set(_vm.uploadData, "taskName", $$v)
                      },
                      expression: "uploadData.taskName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { positive: "relative" },
                  attrs: { label: "考试成绩：" },
                },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticClass: "upload-demo",
                      attrs: {
                        headers: _vm.headers,
                        accept: ".xls, .xlsx",
                        action: _vm.domain + "/marking-main/divide/upload_data",
                        data: _vm.uploadData,
                        "on-remove": _vm.handleRemove,
                        "on-success": _vm.handleSuccess,
                        "on-error": _vm.handleError,
                        "file-list": _vm.fileList,
                        "auto-upload": false,
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            slot: "trigger",
                            size: "small",
                            type: "text",
                          },
                          slot: "trigger",
                        },
                        [_vm._v("请导入成绩")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "download-template",
                      attrs: {
                        download: "",
                        href: _vm.getOssUrl(
                          "oss-cn-hangzhou.aliyuncs.com/template/%E5%88%86%E7%8F%AD%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88%20.xlsx"
                        ),
                      },
                    },
                    [_vm._v("模板下载")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "分区个数：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.uploadData.regionNum,
                      callback: function ($$v) {
                        _vm.$set(_vm.uploadData, "regionNum", $$v)
                      },
                      expression: "uploadData.regionNum",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "分班类型：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.uploadData.taskType,
                        callback: function ($$v) {
                          _vm.$set(_vm.uploadData, "taskType", $$v)
                        },
                        expression: "uploadData.taskType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("普通")]),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("带C+")]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("初三带C+"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "100px", "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: {
                    "padding-left": "20px",
                    "padding-right": "20px",
                  },
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.loading,
                  },
                  on: { click: _vm.submitUpload },
                },
                [_vm._v("下一步")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top" }, [
      _c("div", { staticClass: "step active" }, [
        _c("span", { staticClass: "icon" }, [
          _c("img", {
            staticStyle: { height: "30px" },
            attrs: { src: require("images/check_icon.png"), alt: "" },
          }),
        ]),
        _c("span", { staticClass: "text" }, [_vm._v("选择导入成绩")]),
      ]),
      _c("div", { staticClass: "dots" }, [
        _c("span", { staticClass: "dot" }),
        _c("span", { staticClass: "dot" }),
        _c("span", { staticClass: "dot" }),
        _c("span", { staticClass: "dot" }),
        _c("span", { staticClass: "dot" }),
      ]),
      _c("div", { staticClass: "step" }, [
        _c("span", { staticClass: "index" }, [_vm._v("2")]),
        _c("span", { staticClass: "text" }, [_vm._v("设置规则")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }